import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/fulcrum': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M95.8 164.1l-35.4 43.6-35.4-43.6 35.4-43.5zM144.2 0v211.1l-41.1 44.9 41.1 44.9v211.1l-20.5-198.2-51-57.8 51-57.8zM223.9 164.1l35.4-43.5 35.4 43.5-35.4 43.6zM175.4 211.1v-211.1l20.6 198.2 51 57.8-51 57.8-20.6 198.2v-211.1l41.1-44.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/fulcrum.js
// module id = 842
// module chunks = 0